import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TournamentCard, Chip } from '@lrl/ui';
import { useListPublicTournaments } from '../../api/public';
function tournamentTone(status) {
    if (status === 'active' || status === 'in_progress')
        return 'live';
    if (status === 'draft' || status === 'seeding')
        return 'soon';
    return 'archive';
}
function isLive(t) {
    return t.status === 'active' || t.status === 'in_progress';
}
function isArchive(t) {
    return t.status === 'finished' || t.status === 'archived';
}
export function TournamentList() {
    const { data: tournaments, isLoading, error } = useListPublicTournaments();
    const [filter, setFilter] = useState('all');
    const filtered = (tournaments ?? []).filter((t) => {
        if (filter === 'live')
            return isLive(t);
        if (filter === 'archive')
            return isArchive(t);
        return true;
    });
    return (_jsxs("div", { children: [_jsx("h1", { className: "font-serif text-4xl tracking-[-0.025em] leading-tight mb-6", children: "\u0422\u0443\u0440\u043D\u0438\u0440\u044B" }), _jsx("div", { className: "flex items-center gap-2 mb-6", children: ['all', 'live', 'archive'].map((f) => (_jsx("button", { onClick: () => setFilter(f), className: "bg-transparent border-0 p-0 cursor-pointer", children: _jsx(Chip, { tone: filter === f ? 'primary' : 'outline', children: f === 'all' ? 'Все' : f === 'live' ? 'Live' : 'Архив' }) }, f))) }), isLoading && (_jsx("p", { className: "text-sm text-foreground-soft", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" })), error && (_jsx("p", { className: "text-sm text-clay", children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0442\u0443\u0440\u043D\u0438\u0440\u043E\u0432." })), !isLoading && !error && filtered.length === 0 && (_jsx("p", { className: "text-sm text-foreground-soft", children: "\u041D\u0435\u0442 \u0442\u0443\u0440\u043D\u0438\u0440\u043E\u0432." })), filtered.length > 0 && (_jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4", children: filtered.map((t) => (_jsx(Link, { to: `/tournaments/${t.slug}`, className: "block no-underline", children: _jsx(TournamentCard, { id: t.slug, name: t.name_ru, meta: [
                            t.date_start,
                            t.date_end ? `→ ${t.date_end}` : null,
                            t.venue,
                        ].filter(Boolean).join(' '), tone: tournamentTone(t.status) }) }, t.id))) }))] }));
}
